// 都道府県
$(function () {
  $(".suggest_pref").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_pref/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 市区町村
$(function () {
  $(".suggest_muni").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_muni/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 町丁
$(function () {
  $(".suggest_town").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_town/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 企業
$(function () {
  $(".suggest_company").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_company/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
    },
    select: function (event, ui) {
      var $f = $(this).closest("form");
      var $t = $f.length ? $f : $(document);
      $t.find('input[name="company_id"]').val(ui.item.value);
      $t.find('input[name="selected_company_id"]').val(ui.item.company_id);
      $t.find(".error_message").text("");
      return false;
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 企業除法
$(function () {
  $(".suggest_get_company_info").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_get_company_info/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 企業名
$(function () {
  $(".suggest_company_name").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_company_name/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          console.log('get');
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
    },
    select: function (event, ui) {
      $(this).val(ui.item.value);
      $(this).next().val(ui.item.company_id);
      $(this).parent().parent().find(".delete_flg").children().first().val(1);
      return false;
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 職種
$(function () {
  $(".suggest_kind_of_work").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_kind_of_work/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
          console.log(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
      console.log("e");
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

// 職種
$(function () {
  $(".suggest_kind_of_work_floating").autocomplete({
    source: function (request, response) {
      $.ajax({
        type: "get",
        url: "/suggest_kind_of_work/" + request.term,
        dataType: "json",
      })
        .done(function (res) {
          response(res);
        })
        .fail(function () {
          console.log("通信エラー");
        });
    },
    open: function () {
      $(".ui-autocomplete").css("z-index", 2147483647);
      $(".ui-menu").css("z-index", 2147483647);
      console.log("e");
    },
    select: function (event, ui) {
      $.ajax({
        url: '/ajax/get_kind_of_work_id',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        type: 'GET',
        data: {
          kindofwork: ui.item.value,
        },
        success: function(response) {
          $('input[name="kind_of_work"]').val(response.kindofwork_id);
        }
      });
    },
    delay: 100,
    minLength: 1,
    autoFocus: true,
  });
});

//変化検知
$(function () {
  $(document).on("change", ".check_change", function () {
    // フォームが変更された時に行う処理
    $(this).parent().parent().find(".is_change").val(1);
    // var test = $(this).val()
  });
});

$(function () {
  $(document).on("change", ".check_data_selection_ischangechange", function () {
    // フォームが変更された時に行う処理
    $(this).parent().parent().find(".data_selection_ischange").val(1);
    // var test = $(this).val()
  });
});

$(function () {
  $(document).on("click", ".check_delete", function () {
    // フォームが変更された時に行う処理
    $(this).parent().parent().find(".is_delete").val(1);
    // var test = $(this).val()
  });
});

//リストの検索窓の動き

$(function () {
  document.addEventListener("touchstart", function () {}, true);
});
